"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.LandingPageType=void 0;var s;(function(e){e.BrandsAds="Brands Ads",e.FlashDeals="Flash Deals",e.Gifting="Gifting"})(s||(exports.LandingPageType=s={}));
//# sourceMappingURL=LandingPageType.js.map
